/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetEnrichedInstrumentLinksAppRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/app/GetEnrichedInstrumentLinks.pb'
import {GetEnrichedInstrumentLinksAppResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/app/GetEnrichedInstrumentLinks.pb'


export const getEnrichedInstrumentLinksApp = (request: GetEnrichedInstrumentLinksAppRequest, options?: CashRequestOptions) => post<GetEnrichedInstrumentLinksAppRequest, GetEnrichedInstrumentLinksAppResponse>("/2.0/cash/get-enriched-instrument-links-app", request, {...options, rejectOnError: true })